import React from "react";
import "./About.css";
import SocialIcons from "../SocialIcons";
import amaan from "../assets/amaan.jpg";
function About() {
  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="about-hero-content">
          <span className="about-badge">Solar Wave Technology</span>
          <h1>Powering Homes With Clean Solar Energy</h1>
          <p>
            We provide reliable, affordable, and sustainable solar solutions for
            homes, businesses, farms, and industries across India.
          </p>
          <div className="about-hero-buttons">
            <a href="/contact" className="primary-btn">Get Consultation</a>
            <a href="/products" className="secondary-btn">View Products</a>
          </div>
        </div>
      </section>

      <section className="about-intro">
        <div className="about-text">
          <span className="section-tag">Who We Are</span>
          <h2>Building A Brighter And Greener Future</h2>
          <p>
           I am Amaan from Jhansi, the founder of Solar Wave Technology. My vision is to create a cleaner, greener, and more sustainable future through advanced solar energy solutions. I believe that renewable energy is the key to future growth and environmental protection. Through Solar Wave Technology, my goal is to provide affordable, reliable, and high-quality solar solutions for homes, businesses, and industries. I am committed to continuous innovation, customer satisfaction, and expanding the reach of clean energy across India for a brighter tomorrow.

          </p>
          <p>
            Our team focuses on quality installation, trusted products, timely
            service, and long-term customer support.
          </p>
        </div>

        <div className="about-image-card">
          <img
            src={amaan}
            alt="Solar panels"
          />
        </div>
      </section>

      <section className="stats-section">
        <div className="stat-card">
          <h3>500+</h3>
          <p>Happy Customers</p>
        </div>
        <div className="stat-card">
          <h3>10+</h3>
          <p>Years Experience</p>
        </div>
        <div className="stat-card">
          <h3>1MW+</h3>
          <p>Solar Installed</p>
        </div>
        <div className="stat-card">
          <h3>24/7</h3>
          <p>Support</p>
        </div>
      </section>

      <section className="mission-section">
        <div className="mission-card">
          <h2>Our Mission</h2>
          <p>
            To help every customer save money, reduce dependency on traditional
            electricity, and contribute to a pollution-free future through smart
            solar solutions.
          </p>
        </div>

        <div className="mission-card">
          <h2>Our Vision</h2>
          <p>
            To become a trusted solar energy company known for quality,
            transparency, customer satisfaction, and clean energy innovation.
          </p>
        </div>
      </section>

      <section className="why-about">
        <span className="section-tag">Why Choose Us</span>
        <h2>Reliable Solar Solutions For Every Need</h2>

        <div className="why-grid">
          <div className="why-card">
            <h3>High Quality Products</h3>
            <p>We use trusted solar panels, inverters, batteries, and accessories.</p>
          </div>

          <div className="why-card">
            <h3>Expert Installation</h3>
            <p>Our trained team ensures safe, clean, and long-lasting installation.</p>
          </div>

          <div className="why-card">
            <h3>Affordable Pricing</h3>
            <p>We provide cost-effective solar systems suitable for every budget.</p>
          </div>

          <div className="why-card">
            <h3>After Sales Support</h3>
            <p>We stay connected after installation for service and maintenance.</p>
          </div>
        </div>
      </section>

      <section className="about-cta">
        <h2>Ready To Switch To Solar?</h2>
        <p>Start saving on electricity bills with Solar Wave Technology.</p>
        <a href="/contact">Contact Us Today</a>
      </section>

      <SocialIcons />
    </div>
  );
}

export default About;